import type { TaxReturn } from '@/_types/models/taxReturns';
import type { Row } from '@tanstack/react-table';
import {
  getTotalSignatureCount,
  getCompletedSignatureCount,
} from './_components/TaxReturnCell/components/SignatureCountCell/SignatureCountCell.utils';
import {
  getTotalPaymentCount,
  getCompletedPaymentCount,
} from './_components/TaxReturnCell/components/PaymentsCountCell/PaymentsCountCell.utils';

export const sortBySignatures = (
  rowA: Row<TaxReturn>,
  rowB: Row<TaxReturn>,
): number => {
  const a: TaxReturn = rowA.original;
  const b: TaxReturn = rowB.original;

  if (b.all_signed !== a.all_signed) {
    return b.all_signed ? 1 : -1;
  }

  const allSignatureCountA: number = getTotalSignatureCount(a);
  const allSignatureCountB: number = getTotalSignatureCount(b);

  if (allSignatureCountA !== allSignatureCountB) {
    return allSignatureCountB - allSignatureCountA;
  }

  const completedSignatureCountA: number = getCompletedSignatureCount(a);
  const completedSignatureCountB: number = getCompletedSignatureCount(b);

  return completedSignatureCountB - completedSignatureCountA;
};

export const sortByPayments = (
  rowA: Row<TaxReturn>,
  rowB: Row<TaxReturn>,
): number => {
  const a: TaxReturn = rowA.original;
  const b: TaxReturn = rowB.original;

  const totalA: number = getTotalPaymentCount(a);
  const totalB: number = getTotalPaymentCount(b);
  const completedA: number = getCompletedPaymentCount(a);
  const completedB: number = getCompletedPaymentCount(b);

  const isAllPaidA: boolean = totalA > 0 && completedA === totalA;
  const isAllPaidB: boolean = totalB > 0 && completedB === totalB;

  if (isAllPaidA !== isAllPaidB) {
    return isAllPaidB ? 1 : -1;
  }

  if (totalA !== totalB) {
    return totalB - totalA;
  }

  return completedB - completedA;
};

export const sortByReminderDisabled = (
  rowA: Row<any>,
  rowB: Row<any>,
): number => {
  const a: boolean | null = rowA.original.reminder_disabled;
  const b: boolean | null = rowB.original.reminder_disabled;

  if (a === b) return 0;
  if (a === null) return 1;
  if (b === null) return -1;

  return a ? 1 : -1;
};
